import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { MessageSquare, X, Play } from "lucide-react";
import "./theme.css"; // Import the CSS file
import vid1 from '../../Assesst/vide1.mp4';
import thm1 from '../../Assesst/Image-73.jpg';
import vid2 from '../../Assesst/vid2.mp4';
import thm2 from '../../Assesst/Image-883.jpg';
import vid3 from '../../Assesst/vid3.mp4';
import thm3 from '../../Assesst/Image-121.jpg';
import vid4 from '../../Assesst/vid4.mp4';
import thm4 from '../../Assesst/Image-912.jpg';
import vid5 from '../../Assesst/vid5.mp4';
import thm5 from '../../Assesst/videoframe_0.png';
import vid6 from '../../Assesst/vid6.mp4';
import thm6 from '../../Assesst/629992239_17898564786381730_7476464499665088684_n.jpg';
import thm7 from "../../Assesst/vid1.mp4"
import thm8 from "../../Assesst/thms8.png"



const CollectionsPage = () => {
  const navigate = useNavigate();
  const [selectedVideo, setSelectedVideo] = useState(null);
  const videoRef = useRef(null);

  const collections = [
    {
       video: thm7,
      
      thumbnail: thm8,
    },
    {
      
      video: vid1,
      
      thumbnail: thm1,
    },
     {
      
      video: vid2,
      
      thumbnail: thm2,
    },
    {
      
      video: vid3,
      
      thumbnail: thm3,
    },
    
    
    
    {
      
      video: vid4,
      
      thumbnail: thm4,
    },
    
    {
      
      video: vid5,
      
      thumbnail: thm5,
    },
    {
      
      video: vid6,
      
      thumbnail: thm6,
    },
   
  ];

  const handleExploreCollection = (category) => {
    navigate(`/catalog?category=${category}`);
  };

  const handleBookConsultation = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    navigate('/contact#contact-form');
  };

  const handleViewAllCollections = () => {
    navigate('/catalog');
  };

  const openVideoModal = (collection) => {
    setSelectedVideo(collection);
  };

  const closeVideoModal = () => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
    setSelectedVideo(null);
  };

  // Close modal on ESC key press
  React.useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        closeVideoModal();
      }
    };

    if (selectedVideo) {
      document.addEventListener('keydown', handleEscKey);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscKey);
      document.body.style.overflow = 'unset';
    };
  }, [selectedVideo]);

  return (
    <section 
      id="collections-section"
      className="py-20 bg-gradient-to-br from-white to-gray-50 relative overflow-hidden"
      aria-labelledby="collections-heading"
      style={{
        background: "var(--gradient-bg)",
        minHeight: "100vh",
      }}
    >
      {/* Fullscreen Video Modal */}
      {selectedVideo && (
        <div 
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 backdrop-blur-sm"
          onClick={closeVideoModal}
          role="dialog"
          aria-modal="true"
          aria-label="Video player modal"
        >
          {/* Close Button */}
          <button
            onClick={closeVideoModal}
            className="absolute top-6 right-6 z-50 bg-black/50 hover:bg-black text-white p-3 rounded-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-white/50 backdrop-blur-sm"
            aria-label="Close video"
          >
            <X size={32} />
          </button>

          {/* Video Container */}
          <div className="relative w-full h-full max-w-6xl max-h-[90vh] p-4" onClick={(e) => e.stopPropagation()}>
            {/* Video Title */}
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-full bg-black/50 backdrop-blur-sm text-white px-6 py-2 rounded-b-lg">
              <h3 className="text-lg font-semibold">{selectedVideo.title}</h3>
            </div>
            
            {/* Fullscreen Video */}
            <video
              ref={videoRef}
              src={selectedVideo.video}
              className="w-full h-full object-contain rounded-lg"
              autoPlay
              controls
              loop
              muted
              playsInline
              poster={selectedVideo.thumbnail}
              aria-label={`Video showcasing ${selectedVideo.title}`}
            />
          </div>
        </div>
      )}

      {/* Background Decorative Elements */}
      <div 
        className="absolute top-0 left-0 w-72 h-72 rounded-full -translate-x-1/2 -translate-y-1/2 opacity-60 blur-3xl" 
        aria-hidden="true"
        style={{
          backgroundColor: "var(--color-primary-100)",
        }}
      ></div>
      <div 
        className="absolute bottom-0 right-0 w-96 h-96 rounded-full translate-x-1/3 translate-y-1/3 opacity-70 blur-3xl" 
        aria-hidden="true"
        style={{
          backgroundColor: "var(--color-amber-50)",
        }}
      ></div>
      
      <div className="max-w-7xl mx-auto relative z-10">
        {/* Section Header */}
        <header className="text-center mb-16 px-4">
         
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6"
                      style={{
                        background: "var(--bg-primary-10)",
                        border: "1px solid var(--border-primary-20)",
                      }}
                    >
                      <MessageSquare size={14} style={{ color: "var(--color-primary-400)" }} />
                      <span className="text-sm font-medium" style={{ color: "var(--color-primary-400)" }}>
                        Premium Collections
                      </span>
                    </div>
          
          <h2
            id="collections-heading"
            className="bell-mt-primary text-5xl md:text-6xl font-bold bg-clip-text text-transparent mb-4"
            style={{
              background: "var(--gradient-primary)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
            }}
          >
            Our Exclusive Collections
          </h2>
          
          <p 
            className="text-xl leading-relaxed max-w-2xl mx-auto"
            style={{
              color: "var(--color-gray-600)",
            }}
          >
            Discover the perfect blend of style, functionality, and craftsmanship in our carefully curated kitchen collections.
          </p>
          
          {/* Decorative Line */}
          <div className="flex justify-center mt-6" aria-hidden="true">
            <div 
              className="w-24 h-1 rounded-full"
              style={{
                background: "var(--gradient-primary)",
              }}
            ></div>
          </div>
        </header>

        {/* Collections Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8 px-4">
          {collections.map((collection, index) => (
            <article
              key={index}
              className="relative overflow-hidden rounded-3xl bg-white shadow-xl hover:shadow-2xl transition-all duration-300 group"
              aria-labelledby={`collection-title-${index}`}
            >
              {/* Thumbnail Container with Play Button */}
              <div 
                className="relative aspect-video overflow-hidden cursor-pointer"
                onClick={() => openVideoModal(collection)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    openVideoModal(collection);
                  }
                }}
                aria-label={`Watch video: ${collection.title}`}
              >
                {/* Thumbnail Image */}
                <img
                  src={collection.thumbnail}
                  alt={`${collection.title} thumbnail`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                
                {/* Dark overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                
                {/* Collection title overlay */}
                
                
                {/* Play button overlay - Always visible but subtle, becomes more prominent on hover */}
                
                
                {/* Video indicator badge */}
                
              </div>
            </article>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16 px-4">
          <div 
            className="rounded-2xl p-8 text-white max-w-4xl mx-auto shadow-2xl"
            style={{
              background: "var(--gradient-primary)",
              boxShadow: "var(--shadow-large)",
            }}
          >
            <h3 className="bell-mt-primary text-3xl md:text-4xl font-bold mb-4">
              Need Custom Design?
            </h3>
            <p 
              className="mb-6 text-lg"
              style={{
                color: "rgba(255, 255, 255, 0.9)",
              }}
            >
              Our experts can create the perfect kitchen for your space.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button 
                onClick={handleBookConsultation}
                className="px-8 py-4 rounded-xl font-bold hover:bg-gray-100 transition-colors duration-300 focus:outline-none focus:ring-4 focus:ring-white/50"
                aria-label="Book Free Consultation"
                style={{
                  backgroundColor: "var(--color-white)",
                  color: "var(--color-primary-600)",
                }}
              >
                Book Free Consultation
              </button>
              <button 
                onClick={handleViewAllCollections}
                className="border-2 text-white px-8 py-4 rounded-xl font-bold hover:bg-white/10 transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-white/50"
                aria-label="View All Collections"
                style={{
                  borderColor: "var(--color-white)",
                  color: "var(--color-white)",
                }}
              >
                View All Collections
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CollectionsPage;